
<template>
  <el-skeleton class="loading-wrap" animated>
    <template slot="template">
      <div class="category_bar_box">
        <div class="total-category-bar">
          <div class="category-bar">
            <div class="category-item" v-for="item in 4" :key="item">
              <el-skeleton-item
                variant="text"
                style="width: 50%; height: 30%"
              />
            </div>
          </div>
          <div class="list_tool_bar">
            <div class="list_more">全部课程 ></div>
          </div>
        </div>
      </div>

      <div class="course-category-item" v-for="item in 4" :key="item">
        <div class="course-category-item-header">
          <span class="title">
            <el-skeleton-item
              class="name"
              variant="text"
              style="width: 10rem; height: 3rem"
            />
            <el-skeleton-item
              class="tip"
              variant="text"
              style="width: 20rem; height: 2rem"
            />
          </span>
          <div class="more">查看更多 ></div>
        </div>
        <div class="category-item-content">
          <el-skeleton-item class="category-wrap" variant="image">
          </el-skeleton-item>
          <div class="course-list">
            <!-- thirdItem是课程 -->
            <div class="course-item" v-for="serItem in 8" :key="serItem">
              <div class="course-wrap">
                <img
                  class="course_cover"
                  src="@/assets/images/loading_cover.png"
                />
              </div>
              <el-skeleton-item
                class="course-title"
                variant="text"
                style="width: 50%; text-align: center; height: 10%"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </el-skeleton>
</template>

<script>
export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  //方法集合
  methods: {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang='scss' scoped>
.loading-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  top: 0rem;
  height: calc(100% + 4rem);
  margin-bottom: -4rem;
  right: 4rem;
  width: calc(100% + 8rem);
  padding: 0 4rem;
  box-sizing: border-box;

  .category_bar_box {
    .total-category-bar {
      display: flex;
      height: 7rem;
      justify-content: space-between;
      align-items: center;
      background: linear-gradient(0deg, #edf1f4 0%, #c9dff4 100%);
      //补足外部框架的padding
      width: calc(100% + 16rem);
      position: relative;
      right: 8rem;
      box-sizing: border-box;
      padding: 0 8rem;

      .category-bar {
        display: flex;
        align-items: center;
        height: 100%;

        .category-item {
          width: 18rem;
          height: 100%;
          box-sizing: border-box;
          //调整文字位置
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      }
      .list_tool_bar {
        display: flex;
        align-items: center;
        .list_more {
          cursor: pointer;
          text-align: right;
          font-size: 1.6rem;
          height: 3.7rem;
          line-height: 3.7rem;
          color: #666666;
        }
      }
    }
  }

  .course-category-item {
    width: 100%;
    margin: 10rem 0;
    .course-category-item-header {
      position: relative;
      display: flex;
      justify-content: space-between;
      padding: 2rem 0;
      align-items: flex-end;
      border-bottom: 1px #dce3f2 solid;
      margin-bottom: 2rem;
      overflow: visible;
      .icon {
        position: absolute;
        width: 2.5rem;
        height: auto;
        left: 0rem;
        top: 1.4rem;
      }
      .title {
        display: flex;
        align-items: center;
        .name {
          font-size: 2.2rem;
          color: #333333;
          font-weight: bold;
          margin-right: 1rem;
        }
        .tip {
          font-size: 1.6rem;
          color: #666666;
          font-weight: normal;
        }
      }
      .more {
        color: #666666;
        font-size: 1.6rem;
        cursor: pointer;
      }
    }
    .category-item-content {
      box-sizing: border-box;
      height: 47rem;
      display: flex;
      .category-wrap {
        height: 100%;
        width: 30rem;
        border-radius: 10px;
        margin-right: 3rem;
        box-sizing: border-box;
        background-repeat: no-repeat !important;
        background-size: 30rem auto !important;
        padding: 3.4rem 2.7rem;
        cursor: pointer;
      }
      .course-list {
        flex: 1;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: repeat(auto-fill, 22rem);
        grid-gap: 3rem;

        .course-item {
          display: flex;
          flex-direction: column;
          cursor: pointer;

          &:hover {
            .course-wrap .course_cover {
              transform: scale(1.2);
            }
            .course-title {
              color: $color-primary;
            }
          }
          .course-wrap {
            box-sizing: border-box;
            width: 100%;
            height: 17.5rem;
            border-radius: 10px;
            overflow: hidden;

            .course_cover {
              transition: all 0.2s;
              width: 100%;
              height: 100%;
            }
          }
          .course-title {
            margin-top: 1.5rem;
            margin-left: 1rem;
            color: #333333;
            font-size: 1.6rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1680px) {
  .total-category-bar {
    width: calc(100% + 32rem) !important;
    right: 16rem !important;
    padding: 0 16rem !important;
  }
}
</style>